import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Chip,
  Collapse,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { Card, CardBody } from 'reactstrap';

//const CreateModalActivitiesToggle = () => resetActivitiesForm();

export const ActivityAccordion = ({ collection = [], t }) => {
  const sortedCollection = collection.slice().sort((a, b) => a.name.localeCompare(b.name));
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
        <Typography>{t('activities')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div className="col d-flex justify-content-center">
          <Card className="col-md-12">
            <CardBody>
              {collection.length === 0 && (
                <Alert variant="outlined" severity="info">
                  {t('no_activity')}
                </Alert>
              )}

              {collection.length > 0 && (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell>{t('activity_label')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedCollection.map((row) => (
                        <Row key={row.id} row={row} t={t} />
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardBody>
          </Card>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export const Row = ({ row, t }) => {
  const [open, setOpen] = useState(false);
  const sortedSubActivityList = row?.subActivityList?.slice().sort((a, b) => a.name.localeCompare(b.name));
  const lenSubActivity = row?.subActivityList?.length || 0;

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell style={{ textTransform: 'capitalize' }} component="th" scope="row">
          {row.name}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {lenSubActivity === 0 && (
              <Box sx={{ marginY: 1 }}>
                <Alert severity="warning">{t('no_sub_activity_added')}</Alert>
              </Box>
            )}
            <Box sx={{ marginY: 1 }}>
              <Stack direction="row" spacing={1}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }}>
                    <TableBody>
                      {sortedSubActivityList.map((sub, index) => (
                        <SubRow prodctions={sub.productionList} key={index} name={sub.name} t={t} />
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Stack>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export const SubRow = ({ name, t, prodctions = [] }) => {
  const [open, setOpen] = useState(false);
  const sortedProductions = prodctions.slice().sort((a, b) => a.name.localeCompare(b.name));
  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={{ textTransform: 'capitalize' }} component="th" scope="row">
          {name}
        </TableCell>
        <TableCell align="right"></TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {prodctions.length === 0 && (
              <Box sx={{ marginY: 1 }}>
                <Alert severity="warning">{t('no_production_added')}</Alert>
              </Box>
            )}
            <Box sx={{ marginY: 1 }}>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {sortedProductions.map((production, index) => (
                  <Chip color="success" key={index} label={production.name}
                   sx={{
                    marginRight: 1,
                    marginBottom: 1,
                    ...(index !== 0 && { marginTop: 1 }),
                  }} />
                ))}
              </Stack>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
